// extracted by mini-css-extract-plugin
export default {"container":"kB04BU","backdrop":"yzR0no","position":"j0OJiP","dialog":"zS1NZ_","header":"VwsP6x","title":"_HiBKZ","content":"o3nmdd","footer":"Dms14Y","cancelButton":"RExu8n"};